
var translations = { root: require("./strings_nls.js?raw=true") };
module.exports = function translate(locale) {
  return translations[locale] || translations[locale.substr(0, 2)] || translations["root"];
};